import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';
import { SurveyComment } from '@ps/survey-utils';

import {
  CreateSurveyCommentPayloadDto,
  SurveyCommentDto,
} from './survey-comment.dto';
import { SurveyCommentMapper } from './mappers/survey-comment.mapper';

@Injectable({ providedIn: 'root' })
export class SurveyCommentsApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);
  private readonly _mapper = new SurveyCommentMapper();

  private readonly _baseUrl = this._env.pureSpectrum.url;

  public commentsForSurvey(surveyId: number): Observable<SurveyComment[]> {
    return this._http
      .get<SurveyCommentDto[]>(`${this._baseUrl}/surveys/${surveyId}/comments`)
      .pipe(map((dtos) => this._mapper.fromDtoList(dtos)));
  }

  public createComment(
    surveyId: number,
    body: string,
  ): Observable<SurveyComment> {
    const payload: CreateSurveyCommentPayloadDto = { body };
    return this._http
      .post<SurveyCommentDto>(
        `${this._baseUrl}/surveys/${surveyId}/comments`,
        payload,
        { context: withLoading('drawer') },
      )
      .pipe(map((dto) => this._mapper.fromDto(dto)));
  }
}
